function distance(value) {
  if (value === null || value === undefined || value === "" || typeof value === "boolean") return null;
  const number = Number(value);
  return Number.isFinite(number) && number >= 0 ? number : null;
}

export function normalizeDashboardLowLoad(source) {
  return {
    emptyDistanceKm: distance(source.empty_distance_km),
    partialLoadDistanceKm: distance(source.partial_load_distance_km),
    lowLoadFactors: normalizeFactors(source.low_load_factors),
    lowLoadLoadingSites: normalizeFactors(source.low_load_loading_sites),
    lowLoadTrucks: Array.isArray(source.low_load_trucks) ? source.low_load_trucks.filter(Boolean).map((truck) => ({
      truckId: String(truck.truck_id || ""),
      name: truck.truck_name || truck.truck_id || "Camion non identifié",
      emptyDistanceKm: distance(truck.empty_distance_km),
      partialLoadDistanceKm: distance(truck.partial_load_distance_km),
      lowLoadDistanceKm: distance(truck.low_load_distance_km),
      classifiedDistanceKm: distance(truck.classified_distance_km),
      excludedTripCount: Math.max(0, Number(truck.excluded_trip_count) || 0),
    })) : null,
  };
}

function normalizeFactors(rows) {
  if (!Array.isArray(rows)) return null;
  const normalized = rows.map((row) => ({
    key: String(row?.key || ""), name: row?.name || "Site non identifié", address: row?.address || null,
    distanceKm: distance(row?.distance_km), lowLoadDistanceKm: distance(row?.low_load_distance_km),
    emptyDistanceKm: distance(row?.empty_distance_km),
  }));
  return normalized.every((row) => row.key && row.distanceKm !== null && row.lowLoadDistanceKm !== null
    && row.emptyDistanceKm !== null && row.emptyDistanceKm <= row.lowLoadDistanceKm && row.lowLoadDistanceKm <= row.distanceKm)
    ? normalized : null;
}

export function summarizeDashboardLowLoad(days = []) {
  const validDays = days.filter((day) => day.hasDispatch && day.classifiedDistanceKm > 0 && Number.isFinite(day.lowLoadDistanceKm));
  const splitDays = validDays.filter((day) => Number.isFinite(day.emptyDistanceKm) && Number.isFinite(day.partialLoadDistanceKm));
  const hasSplit = validDays.length > 0 && splitDays.length === validDays.length;
  const classified = validDays.reduce((total, day) => total + day.classifiedDistanceKm, 0);
  const trucks = new Map();
  let detailedDayCount = 0;
  for (const day of validDays) {
    const dayTrucks = day.lowLoadTrucks || [];
    if (dayTrucks.some((truck) => truck.classifiedDistanceKm > 0)) detailedDayCount += 1;
    for (const truck of dayTrucks) {
      const key = truck.truckId || truck.name;
      let total = trucks.get(key);
      if (!total) {
        total = { truckId: key, name: truck.name, emptyDistanceKm: 0, partialLoadDistanceKm: 0,
          lowLoadDistanceKm: 0, classifiedDistanceKm: 0, excludedTripCount: 0, hasSplit: true };
        trucks.set(key, total);
      }
      total.excludedTripCount += truck.excludedTripCount;
      if (!(truck.classifiedDistanceKm > 0) || !Number.isFinite(truck.lowLoadDistanceKm)) continue;
      total.lowLoadDistanceKm += truck.lowLoadDistanceKm;
      total.classifiedDistanceKm += truck.classifiedDistanceKm;
      if (Number.isFinite(truck.emptyDistanceKm) && Number.isFinite(truck.partialLoadDistanceKm)) {
        total.emptyDistanceKm += truck.emptyDistanceKm;
        total.partialLoadDistanceKm += truck.partialLoadDistanceKm;
      } else total.hasSplit = false;
    }
  }
  return {
    emptyDistanceKm: hasSplit ? splitDays.reduce((total, day) => total + day.emptyDistanceKm, 0) : null,
    partialLoadDistanceKm: hasSplit ? splitDays.reduce((total, day) => total + day.partialLoadDistanceKm, 0) : null,
    detailedDayCount,
    validDayCount: validDays.length,
    trucks: [...trucks.values()].map((truck) => {
      const valid = truck.classifiedDistanceKm > 0;
      return { ...truck,
        emptyDistanceKm: valid && truck.hasSplit ? truck.emptyDistanceKm : null,
        partialLoadDistanceKm: valid && truck.hasSplit ? truck.partialLoadDistanceKm : null,
        lowLoadDistanceKm: valid ? truck.lowLoadDistanceKm : null,
        classifiedDistanceKm: valid ? truck.classifiedDistanceKm : null,
        lowLoadDistancePct: valid ? truck.lowLoadDistanceKm / truck.classifiedDistanceKm * 100 : null,
        contributionPts: valid && classified > 0 ? truck.lowLoadDistanceKm / classified * 100 : null,
      };
    }).sort((left, right) => (right.lowLoadDistanceKm ?? -1) - (left.lowLoadDistanceKm ?? -1)
      || left.name.localeCompare(right.name, "fr", { numeric: true })),
  };
}
